import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User clicked an action in the canvas layer (grouped item) toolbar',
  name: 'canvas_layer_toolbar_action_clicked',
  params: [
    {
      description: 'The id of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The layer toolbar action that was clicked',
      name: 'action_taken',
      required: true,
      type: 'enum',
      values: ['edit_text', 'duplicate', 'prompt', 'remove_background', 'delete'],
    },
  ],
};

export default META;
